// extracted by mini-css-extract-plugin
export default {"clipper":"TargetConcentrationField_clipper__61wFV","clipperIcon":"TargetConcentrationField_clipperIcon__8yOLF"};